import { Plugins, Context } from '@leverege/plugin';

/**
 * This function will return an AttributeValueEditor for the given attrName and objRef. The
 * returned object will contain { create }.
 * 
 * To register an AttributeValueEditor, add a plugin to the the type 'AttributeValueEditor'. The
 * object added should { createEditor( props ) }
 */

export default {
  getValidatorsFor: context => {
    const plgs = Plugins.get('AttributeObjectValidator');
    return plgs.filter(plg => {
      return Context.isMatch(context, plg) && plg.objectValidator != null;
    }).map(plg => plg.objectValidator);
  }
};